export const DISCORD_INVITE_LINK = "https://discord.gg/mcTXKt4BtF";
export const EMAIL_LINK = "mailto:contact@nusgdg.org";
export const INSTAGRAM_LINK = "https://www.instagram.com/nusgdg";
export const ITCH_IO_LINK = "https://nusgdg.itch.io";
